import langs from '../langs'
import { cachedTextOffers } from '../main.js'

export let offerTextTemplate = opts => {
  let item = `<li class="item ${opts.name} ${opts.type === 'big' ? 'big col-xxs-12 col-xs-6 col-lg-3' : 'small col-xxs-12 col-xs-6 col-lg-3'}">
                <div class="preloader-bg bg-${Math.ceil(Math.random() * 2)}">
                  <div class="offer-overlay">
                    <div class="offer-overlay-1 stripe"></div>
                    <div class="offer-overlay-2 stripe"></div>
                    <div class="offer-overlay-3 stripe"></div>
                    <div class="offer-overlay-4 stripe"></div>
                    <div class="offer-overlay-5 stripe"></div>
                  </div>
                </div>
              </li>`

    cachedTextOffers.push({name: opts.name})

    return item
}

export let offerTextContent = (route) => {
  let fromName = route.journeys[0]['from-name']
  let toName = route.journeys[0]['to-name']

  return `<a href="${route.url}" class="content">
            <div class="content-text clearfix">
              <strong class="name">
                <span class="from-name">${fromName}</span>
                <span class="delimeter">&nbsp;-&nbsp;</span>
                <span class="to-name">${toName}</span>
              </strong>
              <strong class="price">${formatePrice(route.total)}&nbsp;${langs.CURRENCY}</strong>
            </div>
          </a>`
}

function formatePrice(num) {
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
}



// WEBPACK FOOTER //
// ./src/js/offers/templates/text.js